export default __webpack_public_path__ + "static/logo-b57e7c75d862d1b06b8a5f5d51cc9763.svg";